import React, { Component } from "react";
import { Link } from "react-router-dom";
import * as Loader from "../../common/common";
import { noteCustSupp } from "../../common/config";
import * as authService from "../../services/auth/auth-service";
import * as validation from "../../utils/validations";
import { withRouter } from "../../common/hocs";

class Register extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.reloadCaptcha = this.reloadCaptcha.bind(this);
  }
  state = {
    register: {
      companyName: "",
      pan: "",
      // gst: "",
      email: "",
      countryCode: "",
      mobileNo: "",
      password: "",
      repeatPassword: "",
      userName: "",
      userType: "",
      role: "",
      isVerified: false,
      captcha: "",
    },
    validationErrors: {
      companyNameError: "",
      panError: "",
      gstError: "",
      emailError: "",
      countryCodeError: "",
      mobileNoError: "",
      passwordError: "",
      repeatPasswordError: "",
      recaptchaError: "",
    },
    error: "",
    msg: "",
    loadCaptcha: "",
  };

  onChange(e) {
    const value = e.target.value;
    const name = e.target.name;
    // name === "gst" ||

    if (name === "pan" || name === "companyName") {
      this.setState({
        register: {
          ...this.state.register,
          [name]: value.toUpperCase(),
        },
      });
    } else {
      this.setState({
        register: {
          ...this.state.register,
          [name]: value,
        },
      });
    }

    let validationErrors = Object.assign({}, this.state.validationErrors);

    if (name === "companyName") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.companyNameError = "Please enter Company Name";
      } else {
        validationErrors.companyNameError = "";
      }
    }
    // if (name === "gst") {
    //   validationErrors.gstError = "";
    // }
    if (name === "pan") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.panError = "Please enter PAN";
      } else {
        validationErrors.panError = "";
      }
    }
    if (name === "email") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.emailError = "Please provide Email ";
      } else {
        validationErrors.emailError = "";
      }
    }
    if (name === "mobileNo") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.mobileNoError = "Please provide Mobile Number";
      } else {
        validationErrors.mobileNoError = "";
      }
    }
    if (name === "password") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.passwordError = "Please enter Password";
      } else {
        validationErrors.passwordError = "";
      }
    }
    if (name === "repeatPassword") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.repeatPasswordError = "Please enter Confirm Password";
      } else {
        validationErrors.repeatPasswordError = "";
      }
    }

    this.setState({
      validationErrors: validationErrors,
    });
  }

  onKeyPress(e) {
    if (
      e.which === 32 ||
      (e.which !== 8 && isNaN(String.fromCharCode(e.which)))
    ) {
      e.preventDefault();
    }
  }
  onEnter(e) {
    if (e.which === 13) {
      this.onSubmit();
    }
  }

  componentDidMount() {
    this.reloadCaptcha();
  }

  async reloadCaptcha() {
    try {
      const response = await fetch("/api/auth/captcha");
      const data = await response.json();
      this.setState({
        loadCaptcha: `${data.question} = ?`,
      });
    } catch (err) {
      console.log("Something went wrong", err);
    }
  }

  async onSubmit() {
    const { params } = this.props;
    Loader.showLoader();
    let {
      companyName,
      pan,
      // gst,
      email,
      mobileNo,
      password,
      repeatPassword,
    } = this.state.register;
    let validationFlag = false;
    let validationErrors = Object.assign({}, this.state.validationErrors);
    let captcha = "";
    captcha = this.state.register.captcha;
    if (validation.isNullUndefinedEmpty(companyName)) {
      validationErrors.companyNameError = "Please enter Company Name";
      validationFlag = true;
    }
    if (!validation.isValidcompanyName(companyName)) {
      validationErrors.companyNameError = "Please enter valid Company Name";
      validationFlag = true;
    } else {
      validationErrors.companyNameError = "";
    }
    if (validation.isNullUndefinedEmpty(pan)) {
      validationErrors.panError = "Please enter PAN";
      validationFlag = true;
    } else if (!validation.isValidPAN(pan)) {
      validationErrors.panError = "Please enter valid PAN";
      validationFlag = true;
    } else {
      validationErrors.panError = "";
    }
    // if (gst) {
    //   if (!validation.isValidGST(gst)) {
    //     validationErrors.gstError = "Please enter valid GSTIN";
    //     validationFlag = true;
    //   } else if (gst.slice(2, 12) !== pan) {
    //     validationErrors.gstError = "Not valid GSTIN for the given Pan";
    //     validationFlag = true;
    //   } else {
    //     validationErrors.gstError = "";
    //   }
    // }
    if (validation.isNullUndefinedEmpty(email)) {
      validationErrors.emailError = "Please provide Email";
      validationFlag = true;
    } else if (!validation.isValidEmail(email)) {
      validationErrors.emailError = "Please provide a valid Email";
      validationFlag = true;
    } else {
      validationErrors.emailError = "";
    }
    if (validation.isNullUndefinedEmpty(mobileNo)) {
      validationErrors.mobileNoError = "Please provide Mobile Number ";
      validationFlag = true;
    } else if (!validation.isValidMobileNo(mobileNo)) {
      validationErrors.mobileNoError =
        "Please provide valid Mobile Number of 10 digits";
      validationFlag = true;
    } else {
      validationErrors.mobileNoError = "";
    }

    if (validation.isNullUndefinedEmpty(password)) {
      validationErrors.passwordError = "Please provide Password";
      validationFlag = true;
    }
    if (password) {
      if (!validation.isValidPasswordFormat(password)) {
        validationErrors.passwordError =
          "Password should be minimum 8 characters containing atleast 1 uppercase 1 lowercase 1 digit and 1 special character.";
        validationFlag = true;
      } else {
        validationErrors.passwordError = "";
      }
      if (
        this.state.register.repeatPassword &&
        this.state.register.repeatPassword !== password
      ) {
        validationErrors.repeatPasswordError =
          "Password and Confirm Password must be same";
        validationFlag = true;
      } else {
        validationErrors.repeatPasswordError = "";
      }
    }
    if (validation.isNullUndefinedEmpty(repeatPassword)) {
      validationErrors.repeatPasswordError = "Please enter Confirm Password ";
      validationFlag = true;
    }
    if (repeatPassword) {
      if (
        this.state.register.password &&
        this.state.register.password !== repeatPassword
      ) {
        validationErrors.repeatPasswordError =
          "Password and Confirm Password must be same";
        validationFlag = true;
      } else {
        validationErrors.repeatPasswordError = "";
      }
    }
    // if (!this.state.isVerified) {
    //   validationErrors.recaptchaError = "Please verify that you are a human";
    //   validationFlag = true;
    // } else {
    //   validationErrors.recaptchaError = "";
    // }
    this.setState({
      validationErrors: validationErrors,
    });

    if (validationFlag === false) {
      var data = Object.assign({}, this.state.register);
      data.companyName = companyName.trim();
      data.userName = data.email;
      data.userType = params.id;
      data.captcha = captcha;
      if (params.id === "Customer") {
        data.role = "05";
      }
      if (params.id === "Supplier") {
        data.role = "06";
      }

      let { response, err } = await authService.registerUser(data);
      Loader.hideLoader();
      if (err) {
      } else if (response.data && response.data.err) {
        this.setState({
          error: response.data.err,
          msg: "",
          isVerified: false,
        });
      } else {
        this.setState({
          register: {},
          msg: response.data.msg,
          error: "",
          isVerified: false,
        });
      }
    } else {
      Loader.hideLoader();
      this.setState({
        isVerified: false,
      });
    }
    this.setState({
      register: {
        ...this.state.register,
        captcha: "",
      },
    });
    this.reloadCaptcha();
  }
  render() {
    const { params } = this.props;
    let {
      companyName,
      pan,
      // gst,
      email,
      mobileNo,
      password,
      repeatPassword,
    } = this.state.register;
    let {
      companyNameError,
      panError,
      // gstError,
      emailError,
      mobileNoError,
      passwordError,
      repeatPasswordError,
      recaptchaError,
    } = this.state.validationErrors;

    let sop_link =
      params.id === "Customer" ? (
        <a
          className="mr-2"
          href="/downloads/sop_for_customer_master_creation.pdf"
          download={true}
        >
          here
        </a>
      ) : (
        <a
          className="mr-2"
          href="/downloads/sop_for_supplier_master_creation.pdf"
          download={true}
        >
          here
        </a>
      );
    return (
      <React.Fragment>
        <div className="app flex-row align-items-center">
          <div className="container">
            <div style={{ textAlign: "center" }}>
              <img
                src="/images/logo.jpg"
                width="201"
                height="40"
                alt="logo"
                className="mb-2 mt-2"
              />
            </div>

            <div className="row justify-content-center">
              <div className="col-md-8 card px-0">
                <div className="card-header text-center">
                  <h3>REGISTER</h3>
                </div>
                <div className="card-body p-4">
                  <form onKeyPress={this.onEnter}>
                    <p className="h5">Create Account As {params.id}</p>
                    {this.state.msg ? (
                      <p className="text" style={{ color: "#66CCCC" }}>
                        Verification email has been sent to your email. Please
                        verify your account.
                      </p>
                    ) : null}
                    {this.state.error ? (
                      <p className="text" style={{ color: "red" }}>
                        {this.state.error}
                      </p>
                    ) : null}
                    <div
                      className="miHiding"
                      style={
                        this.state.msg
                          ? { display: "none" }
                          : { display: "block" }
                      }
                    >
                      <p className="text-muted">
                        Note : {noteCustSupp}
                        <br />
                        To download SOP for registering the{" "}
                        {params.id} Master in Ameya e-KYC system please click{" "}
                        {sop_link}
                      </p>
                      <div className="row">
                        <div className="col-md-6">
                          <label>
                            Company Name<span className="mandatory">*</span>
                          </label>
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="fa fa-user"></i>
                              </span>
                            </div>
                            <input
                              className={
                                companyNameError
                                  ? "is-invalid form-control"
                                  : "form-control"
                              }
                              type="text"
                              placeholder="Company Name"
                              maxLength="300"
                              name="companyName"
                              value={companyName || ""}
                              onChange={this.onChange}
                              autoComplete="off"
                            />
                          </div>
                          <div className="form-group">
                            <span className="error-msg">
                              {companyNameError}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <label>
                            PAN<span className="mandatory">*</span>
                          </label>
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="fa fa-id-badge"></i>
                              </span>
                            </div>
                            <input
                              className={
                                panError
                                  ? "is-invalid form-control"
                                  : "form-control"
                              }
                              type="text"
                              placeholder="PAN"
                              maxLength="10"
                              name="pan"
                              value={pan || ""}
                              onChange={this.onChange}
                              autoComplete="off"
                            />
                          </div>
                          <div className="form-group">
                            <span className="error-msg">{panError}</span>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <label>
                            Mobile Number<span className="mandatory">*</span>
                          </label>
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="fa fa-mobile"></i>
                              </span>
                            </div>
                            {/* <span>
                                                    <input className={countryCodeError ? "is-invalid form-control" : "form-control"} type="text" placeholder="XX" name="countryCode" maxLength="3" value={countryCode || ''} onChange={this.onChange} onKeyPress={this.onKeyPress} style={{ width: "50px" }} autoComplete="off" />
                                                </span> */}
                            <input
                              className={
                                mobileNoError
                                  ? "is-invalid form-control"
                                  : "form-control"
                              }
                              type="text"
                              placeholder="Mobile"
                              name="mobileNo"
                              maxLength="10"
                              value={mobileNo || ""}
                              onChange={this.onChange}
                              onKeyPress={this.onKeyPress}
                              autoComplete="off"
                            />
                          </div>
                          {/* <div className="form-group">
                                                <span className="error-msg">{countryCodeError}</span>
                                            </div> */}
                          <div className="form-group">
                            <span className="error-msg">{mobileNoError}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label>
                            Email<span className="mandatory">*</span>
                          </label>
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="fa fa-envelope"></i>
                              </span>
                            </div>
                            <input
                              className={
                                emailError
                                  ? "is-invalid form-control"
                                  : "form-control"
                              }
                              type="text"
                              placeholder="Email"
                              maxLength="150"
                              name="email"
                              value={email || ""}
                              onChange={this.onChange}
                              autoComplete="off"
                            />
                          </div>
                          <div className="form-group">
                            <span className="error-msg">{emailError}</span>
                          </div>
                        </div>
                      </div>

                      {/* <div className="row">
                        <div className="col-md-12">
                          <label>GSTIN</label>
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="fa fa-id-card"></i>
                              </span>
                            </div>
                            <input
                              className={
                                gstError
                                  ? "is-invalid form-control"
                                  : "form-control"
                              }
                              type="text"
                              placeholder="GSTIN"
                              maxLength="15"
                              name="gst"
                              value={gst || ""}
                              onChange={this.onChange}
                              autoComplete="off"
                            />
                          </div>
                          <div className="form-group">
                            <span className="error-msg">{gstError}</span>
                          </div>
                        </div>
                      </div> */}

                      <div className="row">
                        <div className="col-md-6">
                          <label>
                            Password<span className="mandatory">*</span>
                          </label>
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="fa fa-lock"></i>
                              </span>
                            </div>
                            <input
                              className={
                                passwordError
                                  ? "is-invalid form-control"
                                  : "form-control"
                              }
                              type="password"
                              maxLength="50"
                              placeholder="Password"
                              name="password"
                              value={password || ""}
                              onChange={this.onChange}
                              autoComplete="off"
                            />
                          </div>
                          <div className="form-group">
                            <span className="error-msg">{passwordError}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label>
                            Confirm Password<span className="mandatory">*</span>
                          </label>
                          <div className="input-group mb-4">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="fa fa-lock"></i>
                              </span>
                            </div>
                            <input
                              className={
                                repeatPasswordError
                                  ? "is-invalid form-control"
                                  : "form-control"
                              }
                              type="password"
                              maxLength="50"
                              placeholder="Confirm Password"
                              name="repeatPassword"
                              value={repeatPassword || ""}
                              onChange={this.onChange}
                              autoComplete="off"
                            />
                          </div>
                          <div className="form-group">
                            <span className="error-msg">
                              {repeatPasswordError}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="input-group">
                        <span onClick={this.reloadCaptcha}>
                          <i className="fas fa-sync mt-5 ml-2"></i>
                        </span>
                        
                        <span className="form-control mt-4" style={{ border: 'none' }}>
                          {this.state.loadCaptcha}
                        </span>

                        <input
                          className="form-control col-md-2 mt-4"
                          type="text"
                          value={this.state.register.captcha}
                          placeholder="Answer"
                          name="captcha"
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <div className="form-group">
                          <span className="error-msg">{recaptchaError}</span>
                        </div>
                      </div>
                      <button
                        className="btn btn-block btn-primary rounded-0"
                        type="button"
                        onClick={this.onSubmit}
                      >
                        Create Account
                      </button>
                    </div>
                  </form>
                  <div style={{ textAlign: "center" }}>
                    <Link to="/Login">Back to Login</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

// HOC to inject router params
export default withRouter(Register);